// src/services/authService.ts

import { API_URL } from "../utils/constants";
import showToast from "../utils/show.toast";
// src/services/authService.ts
import { postRequest } from "./api.service";

// export interface LoginResponse {
//   message: string;
//   result: {
//     accessToken: string;
//     refreshToken: string;
//     userDetails: {
//       email: string;
//       first_name: string;
//       id: number;
//       last_name: string;
//       profile: string;
//     };
//     role: {
//       type: string;
//       level: number;
//     };
//   };
// }

export interface LoginResponse {
  statusCode: number;
  status: string;
  message: string;
  result: {
    success: boolean;
    requires2FA: boolean;
    loginSessionId: string;
    message: string;
    expiresInSeconds: string;
  };
}

export const loginService = async (
  email: string,
  password: string
): Promise<any> => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, role: "admin" }),
    });

    return response;
  } catch (error) {
    const msg =
      error instanceof Error
        ? error.message
        : "Apologies, there was error login.";
    throw new Error(msg);
  }
};
